export const screenSize = {
	mobile: `(max-width: ${768}px)`,
	tablet: `(max-width: ${1024}px)`,
	sm: `(min-width: ${768}px)`,
	md: `(min-width: ${1024}px)`,
	lg: `(min-width: ${1440}px)`,
};
